import Vue from 'vue'
import Vuetable from 'vuetable-2'
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue';
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'
import $ from 'jquery'
import axios from "axios";
import JsonExcel from 'vue-json-excel'
import vSelect from 'vue-select'
import Header from "../../components/Header.vue";

Vue.component('downloadExcel', JsonExcel)
Vue.component('v-select', vSelect)


export default {
    components: {
        Header,
        Vuetable,
        VuetablePagination,
        VuetableFieldCheckbox,
        VuetableFieldMixin
    },
    data: function() {
        return {
            pageTitle: "Liste des clients",

            vuetable: {
                moreParams: {},
                fields: [
                    {
                        name: 'nom_client',
                        title: 'Libellé',
                        sortField: 'nom_client',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'login_client',
                        title: 'Login',
                        sortField: 'login_client',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'tel_client',
                        title: 'Contact',
                        sortField: 'tel_client',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'email_client',
                        title: 'Email',
                        sortField: 'email_client',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'adresse_client',
                        title: 'Adresse',
                        sortField: 'adresse_client',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'type_client',
                        title: 'Type du client',
                        sortField: 'type_client',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'cin_client',
                        title: 'CIN',
                        sortField: 'cin_client',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'nif_client',
                        title: 'NIF',
                        sortField: 'nif_client',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'stat_client',
                        title: 'STAT',
                        sortField: 'stat_client',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'rcs_client',
                        title: 'RCS',
                        sortField: 'rcs_client',
                        dataClass: 'text-left'
                    },

                    {
                        name: 'actions',
                        title: '-',
                        titleClass: 'text-center column_fixed-header',
                        width: "80px",
                        dataClass: "text-center column_fixed"
                    }

                ],
                sortOrder: [
                    { field: 'nom_client', direction: 'asc' }
                ],
                css: {
                    table: {
                        // tableClass: 'table table-striped table-bordered table-hovered',
                        tableClass: 'table-responsive text-nowrap w-100 d-block d-md-table table table-bordered table-hover',
                        loadingClass: 'loading',
                        ascendingIcon: 'fas fa-arrow-up fa-sm',
                        descendingIcon: 'fas fa-arrow-down fa-sm',
                        handleIcon: 'fas fa-bars fa-sm',
                    },
                    pagination: {
                        infoClass: 'pull-left ',
                        wrapperClass: 'vuetable-pagination text-center',
                        activeClass: 'btn-secondary',
                        disabledClass: 'disabled',
                        pageClass: 'btn btn-border',
                        linkClass: 'btn btn-border',
                        icons: {
                            first: '',
                            prev: '',
                            next: '',
                            last: '',
                        },
                    }
                },
            },
            preview_link:[{src:''}],
            exportexcel: {
                json_fields: {
                    'Nom de la Tresorerie': 'nom_client',
                    'Type de la Tresorerie': 'type_tresorerie',
                    'Solde': 'solde',
                    'Nom du compte': 'nom_compte',
                    'Numero du compte': 'numero_compte',
                    'BIC': 'bic',
                    'IBAN': 'iban',
                    'BANQUE Correspondante': 'banque_correspondante',
                    'Code swift': 'code_swift',
                    'Utilisateur associé': 'nom'

                },
                json_data: [],
                json_meta: [
                    [{
                        'key': 'charset',
                        'value': 'utf-8'
                    }]
                ],
            },
            motCle: "",
            crudform: {
                id: "",
                nom_client: "",
                tel_client: "",
                email_client: "",
                login_client: "",
                adresse_client: "",
                type_client: "PARTICULIER",
                nif: "",
                stat: "",
                rcs: "",
                cin_client: "",
                mdp_client: '',
                confirmation: '',
                document:[{
                    id:'',
                    id_client:'',
                    libeller_document:'',
                    piece_jointe_document:'',
                }]
            },
            crudmodaltitle: "Nouveau Client",
            btn_submit:false,
        }
    },
    methods: {



        onRowClass(dataItem, index) {
            if (index == "") console.log("");

            if(Number(dataItem.solde) < 0) {
                // return 'text-danger text-bold';
            }
        },
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData)
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page)
        },

        editRow(rowData) {
            //alert("You clicked edit on" + JSON.stringify(rowData))
            this.preview_link = [];
            axios.get(this.BASE_URL + "/client/get/" + rowData.id).then(response => {
                this.crudform = response.data[0];
                if (response.data[0].document.length>0){
                    this.crudform.document.forEach((value) => {
                        this.preview_link.push({
                            src:this.BASE_URL+"/upload/dossier/client/"+value.piece_jointe_document
                        })
                    })
                }
            });
            this.crudmodaltitle = "Editer une client";
            this.openModal();
        },
        deleteRow(rowData) {
            //alert("You clicked delete on" + JSON.stringify(rowData));
            var that = this;
            this.$bvModal.msgBoxConfirm('Voulez-vous vraiment supprimer cette ligne?', {
                title: 'Confirmation',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'Supprimer',
                cancelTitle: 'Annuler',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    console.log(value);
                    if (value == true) {
                        axios.post(that.BASE_URL + "/client/delete/" + rowData.id).then(function(response) {
                            console.log(response);
                            //this.message_reponse = response.data.msg;
                            if (response.data.error === "") {
                                console.log(response.data.message);
                                that.setFilter();
                                Vue.$toast.open({
                                    message: response.data.message,
                                    type: 'success',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            } else {
                                console.log("Erreur");
                                Vue.$toast.open({
                                    message: response.data.error,
                                    type: 'error',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            }
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                    // An error occurred
                })

        },
        onLoading() {
            console.log('loading... show your spinner here')
        },
        onLoaded() {
            console.log('loaded! .. hide your spinner here');
        },
        setFilter() {
            this.vuetable.moreParams.filter = this.motCle;
            this.vuetable.moreParams.criteriacol = this.criteriacol;
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        resetFilter() {
            this.motCle = "";
            this.criteriacol = "";
            this.vuetable.moreParams.filter = this.motCle;
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        onExport() {

            this.exportexcel.json_data = this.$refs.vuetable.$data.tableData;
            $("#excel-download").trigger("click");
        },
        openModal() {
            this.fetchData();
            this.$bvModal.show("crudmodal");
        },
        closeModal() {
            this.$bvModal.hide("crudmodal");
        },
        pushData(){
            this.crudform.document.push({
                id:'',
                id_client:'',
                libeller_document:'',
                piece_jointe_document:'',
            });
            this.preview_link.push({
                src:''
            });
        },
        spliceData(index,id_document){
            if (id_document >0){
                var that = this;
                this.$bvModal.msgBoxConfirm('Voulez-vous vraiment supprimer cette ligne?', {
                    title: 'Confirmation',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Supprimer',
                    cancelTitle: 'Annuler',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                    .then(value => {
                        console.log(value);
                        if (value == true) {
                            axios.post(that.BASE_URL + "/client/deletedocument/" + id_document).then((response)=> {
                                console.log(response);
                                this.crudform.document.splice(index,1);
                                this.preview_link.splice(index,1);
                            });
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        // An error occurred
                    })
            }else{
                this.crudform.document.splice(index,1);
                this.preview_link.splice(index,1);
            }

        },
        changeValue(){
            this.crudform.nif = '';
            this.crudform.stat = '';
            this.crudform.rcs = '';
            this.crudform.cin_client = '';
        },
        addRow() {
            this.preview_link=[{src:''}];
            this.crudmodaltitle = "Nouveau client";
            this.crudform = {
                id: "",
                nom_client: "",
                login_client: "",
                tel_client: "",
                email_client: "",
                adresse_client: "",
                type_client: "PARTICULIER",
                nif: "",
                stat: "",
                rcs: "",
                cin_client: "",
                mdp_client: '',
                confirmation: '',
                document:[{
                    id:'',
                    id_client:'',
                    libeller_document:'',
                    piece_jointe_document:'',
                }]
            };
            this.openModal();
        },
        onSubmit() {
            var that = this;

            this.$bvModal.msgBoxConfirm('Voulez-vous vraiment continuer l\'enregistrement?', {
                title: 'Confirmation',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Continuer',
                cancelTitle: 'Annuler',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    console.log(value);
                    if (value == true) {
                        var link = '';
                        that.btn_submit = true;

                        link = that.crudform.id == '' ? that.BASE_URL + "/client/addaction" : that.BASE_URL + "/client/editaction";

                        axios.post(link, $("#formulaire").serialize()).then(function(response) {
                            console.log(response);
                            that.btn_submit = false;
                            //this.message_reponse = response.data.msg;
                            if (response.data.error === "") {
                                console.log("Enregistrement effectué avec succès!");
                                that.closeModal();
                                that.setFilter();
                                Vue.$toast.open({
                                    message: 'Enregistrement effectué avec succès!',
                                    type: 'success',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            } else {
                                console.log("Erreur");
                                Vue.$toast.open({
                                    message: response.data.error,
                                    type: 'error',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            }
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                    // An error occurred
                });
        },
        fetchData: function() {
            axios.get(this.BASE_URL + "/tresoreries/fetchdata").then(response => {
                console.log(response)
                this.listdata = response.data;
            });
        },
        chargePieceJointe(index){
            $("#piece_jointe"+index).trigger('click');
        },
        // seePieceJointe(index){
            // if (this.crudform.document[index].piece_jointe_document !=''){
            //
            // }
        // },
        resetPieceJointe(index){
            this.preview_link[index].src= '';
            this.crudform.document[index].piece_jointe_document ='';
        },
        createImages(file,index) {
            var reader = new FileReader();
            var that = this;
            reader.onload = (e) => {
                that.preview_link[index].src = e.target.result;
            };
            reader.readAsDataURL(file);
        },

        uploadImage(event,index) {
            const URL = this.BASE_URL + '/import/uploadaction';

            let data = new FormData();
            data.append('name', 'file-input');
            data.append('file-input', event.target.files[0]);
            console.log(event.target.files[0]);
            var files = event.target.files || event.dataTransfer.files;
            this.createImages(files[0],index);

            let config = {
                header: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: progressEvent => {
                    var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                    console.log(percentCompleted)
                }
            }
            var that = this;
            axios.post(
                URL,
                data,
                config
            ).then(
                response => {
                    console.log('image upload response > ', response);

                    that.crudform.document[index].piece_jointe_document = response.data.upload_data.file_name;



                }
            ).catch(error => {
                console.log(error);
            })
        },


    },

    created: function() {
        this.$emit('change-page', this.pageTitle);
        this.motCle = "";
        this.criteriacol = "";

    },
    mounted: function() {

    }
}
